module.exports = __webpack_public_path__ + "img/td-2.3cddb09e.jpg";